import Select from 'react-select'
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router-dom";
import AsideContacts from '../../components/AsideContacts';
import AsideNewFeed from '../../components/AsideNewFeed';
import EditMusic from '../../components/EditMusic';
import EditVideo from '../../components/EditVideo';
import EditAchievements from '../../components/EditAchievements';
import EditLinks from '../../components/EditLinks';
import { useDispatch, useSelector } from "react-redux";
import settingsActions from "../../redux/settings/actions";
import { genres as genreC, locations, userRoles as rolesC } from "../../assets/constants";
// Components
import styles from "../settings/settingsTabs/details/style.module.scss";
import { Col, Form, Input, Row } from "antd";
import { imageToBase64 } from "../../helpers.js/images";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const { useRef } = React;

function EditProfile() {
    const user_genres = genreC.map((role) => {
        return { value: role, label: role };
    });
    const user_roles = rolesC.map((role) => {
        return { value: role, label: role };
    });
    const [form] = Form.useForm();
    const childRef = useRef();
    const videoRef = useRef();
    const achivementRef = useRef();
    const { currentUser } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
    }));

    const notify = () => toast("Updated! 🎉 ");

    const dispatch = useDispatch();
    const [genres, setGenres] = useState(genreC);
    const [lastName, setLastname] = useState(currentUser.lastName);
    const [firstName, setFirstname] = useState(currentUser.firstName);
    const [userName, setUsername] = useState(currentUser.username);
    const [email, setEmail] = useState(currentUser.email);
    const [location, setLocation] = useState(currentUser.location);
    const [bio, setBio] = useState(currentUser.bio);
    const [role, setRole] = useState(currentUser.role);
    const [genre, setGenre] = useState(currentUser.genre);
    let gen = currentUser.genres.map((role) => {
        return { value: role, label: role };
    });

    let rolebased;
    if (currentUser?.role) {
        rolebased = currentUser.role.map((role) => {
            return { value: role, label: role };
        });
    }
    else {
        rolebased = [{ value: currentUser.accountType, label: currentUser.accountType }]

    }

    const [arrgen, setArrgen] = useState(gen)
    const [rolegen, setRolegen] = useState(rolebased)
    console.log('rolegen', rolegen)
    const [currentstep, setCurrentStep] = useState(0)
    const [profileImage, setProfileImage] = useState(currentUser?.profileImageUrl);
    const [profileImagePreview, setProfileImagePreview] = useState(
        currentUser?.profileImageUrl
    );
    const [coverImage, setCoverImage] = useState(currentUser.coverImageUrl);
    const [coverImagePreview, setCoverImagePreview] = useState(
        currentUser.coverImageUrl
    );
    const [status, setChangeStatus] = useState();

    const styless = {
        container: (base) => ({
            ...base,
            flex: 1,
        }),
    };
    console.log(currentstep)
    const onFinish = (values) => {

        if (currentstep == 1) {
            childRef.current.handleUpdate()
        }
        else if (currentstep == 2) {
            videoRef.current.handleUpdateVideo()
        }
        else if (currentstep == 3) {
            achivementRef.current.handleUpdate()
        }
        else if (currentstep == 0) {
            console.log('values', values)
            console.log('called')
            const agn = arrgen.map(a => {
                return a.value;
            })
            const roles = rolegen.map(a => { return a.value })
            const st = values.newStatus
                ? `${values.status} ${values.newStatus}`
                : values.status;
            delete values.status;
            delete values.newStatus;
            dispatch({
                type: settingsActions.UPDATE_USER_DETAILS,
                payload: {
                    // ...values,
                    status: st,
                    firstName: firstName,
                    lastName: lastName,
                    username: userName,
                    location: location,
                    bio: bio,
                    email: email,
                    role: roles,
                    genres: agn,
                    profileImage:
                        profileImage === currentUser?.profileImageUrl ? null : profileImage,
                    coverImage:
                        coverImage === currentUser.coverImageUrl ? null : coverImage,
                },
            });

        }

        toast.success("Sucessfully Updated", { autoclose: false });
    };

    const onChangeProfileImage = async (e) => {
        if (e.target.files.length === 1) {
            const file = e.target.files[0];
            if (3 < file.size / 1024 / 1024) {
                return;
            }
            const preview = await imageToBase64(file);
            setProfileImage(file);
            setProfileImagePreview(preview);
        }
    };

    const onChangeCoverImage = async (e) => {
        if (e.target.files.length === 1) {
            const file = e.target.files[0];
            if (3 < file.size / 1024 / 1024) {
                return;
            }
            const preview = await imageToBase64(file);
            setCoverImage(file);
            setCoverImagePreview(preview);
        }
    };
    console.log('arrrrrrrrr', arrgen)


    return (
        <>
            {/* Left Aside */}
            <AsideNewFeed></AsideNewFeed>

            <section className="main-content">
                <div className="middle-box">
                    <div className="row">
                        <div className="col-sm-12 mb-3">
                            <div className="card border-0 rounded-xl shadow-xs overflow-hidden mb-3">
                                <div className="card-header d-flex align-items-center bg-primary px-4 py-2 fw-bold text-white">
                                    <Link to="/Settings" className="d-inline-flex align-middle text-white py-3 pe-4">
                                        <svg className="icon icon-8x"><use href="#icon_arrowback"></use></svg>
                                    </Link>
                                    Account Details
                                </div>
                                <ul className="nav nav-tabs profile-tab border-0 ps-4" role="tablist">
                                    <li className="list-inline-item me-4 me-sm-5">
                                        <Link to="#detailsbox" data-bs-toggle="tab" className="active" onClick={() => setCurrentStep(0)}>Details</Link>
                                    </li>
                                    <li className="list-inline-item me-4 me-sm-5">
                                        <Link to="#musicbox" data-bs-toggle="tab" onClick={() => setCurrentStep(1)}>Music</Link>
                                    </li>
                                    <li className="list-inline-item me-4 me-sm-5">
                                        <Link to="#videobox" data-bs-toggle="tab" onClick={() => setCurrentStep(2)}>Videos</Link>
                                    </li>
                                    <li className="list-inline-item me-4 me-sm-5">
                                        <Link to="#achievementsbox" data-bs-toggle="tab" onClick={() => setCurrentStep(3)}>Achievements</Link>
                                    </li>
                                    <li className="list-inline-item pe-4">
                                        <Link to="#linksbox" data-bs-toggle="tab" onClick={() => setCurrentStep(4)}>Links</Link>
                                    </li>
                                    <li style={{ alignSelf: 'center', marginLeft: 'auto', paddingRight: '15px' }}>

                                        <button type="button" className="btn btn-primary rounded-pill fw-semibold px-4" onClick={onFinish}>
                                            <ToastContainer />
                                            Save
                                        </button>

                                    </li>
                                </ul>
                            </div>

                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="detailsbox">

                                    <div className="card border-0 rounded-xl shadow-xs">
                                        <div className="card-body p-4 p-md-5">
                                            <div className={styles.detailsContainer}>
                                                <Form
                                                    name="about-you-form"
                                                    //onFinish={onFinish}
                                                    requiredMark={false}
                                                    initialValues={currentUser}
                                                >
                                                    <div className={styles.mainContent}>

                                                        <Row justify="space-between" align="top" className={styles.pictures}>
                                                            <Col span={11}>
                                                                <div className={styles.title}></div>
                                                                <div className={styles.uploadImages}>
                                                                    <div
                                                                        className={styles.thumb}
                                                                        style={
                                                                            profileImagePreview
                                                                                ? {
                                                                                    backgroundImage: `url(${profileImagePreview})`,
                                                                                }
                                                                                : {}
                                                                        }
                                                                    />
                                                                    <div className={styles.uploadButton}>
                                                                        <label htmlFor="profilePicture">Upload new photo</label>
                                                                        <input
                                                                            id="profilePicture"
                                                                            type="file"
                                                                            accept="image/*"
                                                                            onChange={onChangeProfileImage}
                                                                        />
                                                                        <span>Image format with max 3mb</span>
                                                                    </div>
                                                                    <div className={styles.removeButton}>
                                                                        <button
                                                                            onClick={() => {
                                                                                setProfileImagePreview(null);
                                                                                setProfileImage(null);
                                                                            }}
                                                                        >
                                                                            Remove
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col span={11}>
                                                                <div className={styles.title}></div>
                                                                <div className={styles.uploadImages}>
                                                                    <div
                                                                        className={styles.thumb}
                                                                        style={
                                                                            coverImagePreview
                                                                                ? { backgroundImage: `url(${coverImagePreview})` }
                                                                                : {}
                                                                        }
                                                                    />
                                                                    <div className={styles.uploadButton}>
                                                                        <label htmlFor="coverPicture">Upload new cover</label>
                                                                        <input
                                                                            id="coverPicture"
                                                                            type="file"
                                                                            accept="image/*"
                                                                            onChange={onChangeCoverImage}
                                                                        />
                                                                        <span>Image format with max 3mb</span>
                                                                    </div>
                                                                    <div className={styles.removeButton}>
                                                                        <button
                                                                            onClick={() => {
                                                                                setCoverImagePreview(null);
                                                                                setCoverImage(null);
                                                                            }}
                                                                        >
                                                                            Remove
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>

                                                    <div className="row gy-4">
                                                        <div className="col-md-6">
                                                            <label htmlFor="inputfname" className="form-label fw-semibold fs-13 text-muted">First Name</label>
                                                            <input type="text" className="form-control" id="inputfname" value={firstName} onChange={(e) => setFirstname(e.target.value)} defaultValue={currentUser.firstName} placeholder="Enter First Name" />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="inputlname" className="form-label fw-semibold fs-13 text-muted">Last Name</label>
                                                            <input type="text" className="form-control" id="inputlname" value={lastName} onChange={(e) => setLastname(e.target.value)} defaultValue={currentUser.lastName} placeholder="Enter Lastname .." />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="inputUsername" className="form-label fw-semibold fs-13 text-muted">Username</label>
                                                            <input type="text" className="form-control" id="inputUsername" value={userName} onChange={(e) => setUsername(e.target.value)} defaultValue={currentUser.username} placeholder="Enter username" spellCheck="false" />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="inputEmail" className="form-label fw-semibold fs-13 text-muted">Email</label>
                                                            <input type="text" className="form-control" id="inputEmail" value={email} onChange={(e) => setEmail(e.target.value)} defaultValue={currentUser.email} placeholder="Enter email address" spellCheck="false" />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label className="form-label fw-semibold fs-13 text-muted">Role</label>
                                                            <div>
                                                                <Select
                                                                    isMulti
                                                                    styles={styless}
                                                                    value={rolegen}
                                                                    sty
                                                                    name="colors"
                                                                    options={user_roles}
                                                                    className="basic-multi-select"
                                                                    classNamePrefix="select"
                                                                    onChange={(v) => v.length < 4 ? setRolegen(v) : null}
                                                                />

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="" className="form-label fw-semibold fs-13 text-muted">Genres</label>
                                                            <div>
                                                                <Select
                                                                    isMulti
                                                                    styles={styless}
                                                                    value={arrgen}
                                                                    sty
                                                                    name="colors"
                                                                    options={user_genres}
                                                                    className="basic-multi-select"
                                                                    classNamePrefix="select"
                                                                    onChange={(v) => v.length < 4 ? setArrgen(v) : null}
                                                                />

                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <label htmlFor="inputBio" className="form-label fw-semibold fs-13 text-muted">About</label>
                                                            <textarea type="text" className="form-control" rows="4" id="inputBio" placeholder="Upto 180 Characters" value={bio} onChange={(e) => setBio(e.target.value)} defaultValue={currentUser.bio} spellCheck="false"></textarea>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="inputlocation" className="form-label fw-semibold fs-13 text-muted">Location</label>
                                                            <select className="form-select form-control" id="inputLocation" value={location} onChange={(e) => setLocation(e.target.value)} defaultValue={currentUser.location} >
                                                                {locations.map((x, y) => <option key={y}>{x}</option>)}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="inputstatus" className="form-label fw-semibold fs-13 text-muted">Status</label>
                                                            <select className="form-select form-control" id="inputstatus" value={status} onChange={(e) => setChangeStatus(e.target.value)}>
                                                                <option defaultValue>{currentUser.status}</option>
                                                                <option value="Working at">Working at</option>
                                                                <option value="Independent">Independent</option>
                                                                <option value="Signed To">Signed To</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="inputmanagement" className="form-label fw-semibold fs-13 text-muted">Management</label>
                                                            <select className="form-select form-control" id="inputmanagement">
                                                                <option value="Manager">Manager</option>
                                                                <option value="Management">Management</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="" className="form-label">&nbsp;</label>
                                                            <input type="text" className="form-control" defaultValue="@" />
                                                        </div>
                                                    </div>

                                                </Form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="musicbox">
                                    <div className="card border-0 rounded-xl shadow-xs">
                                        <div className="card-body p-3 p-md-4">
                                            <EditMusic ref={childRef}></EditMusic>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="videobox">
                                    <div className="card border-0 rounded-xl shadow-xs">
                                        <div className="card-body p-3 p-md-4">
                                            <EditVideo ref={videoRef}></EditVideo>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="achievementsbox">
                                    <div className="card border-0 rounded-xl shadow-xs">
                                        <div className="card-body p-3 p-md-4">
                                            <EditAchievements ref={achivementRef}></EditAchievements>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="linksbox">
                                    <div className="card border-0 rounded-xl shadow-xs">
                                        <div className="card-body p-3 p-md-4">
                                            <EditLinks></EditLinks>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Right Aside */}
            <AsideContacts></AsideContacts>
        </>
    );
}

export default withRouter(EditProfile);